var map = {
	"./admin.js": "3RQi",
	"./bindWx.js": "r0km",
	"./common.js": "Z5nh",
	"./config.js": "Co5U",
	"./index.js": "BnX+",
	"./login.js": "aLq6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/oWN";


//////////////////
// WEBPACK FOOTER
// ./src/fetch/api \.js$
// module id = /oWN
// module chunks = 7